import './utils/sentry/init';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import ReduxQueryProvider from 'utils/redux-query/ReduxQueryProvider';
import SentryErrorBoundary from 'utils/sentry/SentryErrorBoundary';
import PaymentsApp from 'views/PaymentsApp';

import store from './store/payments/store';

render(
  <SentryErrorBoundary>
    <Provider store={store}>
      <ReduxQueryProvider>
        <PaymentsApp />
      </ReduxQueryProvider>
    </Provider>
  </SentryErrorBoundary>,
  document.getElementById('app'),
);
